/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MapPin = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10ZM13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.1716 11.5 10.5 10.8284 10.5 10C10.5 9.17157 11.1716 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 21.5L11.1368 22.7267L11.1328 22.7239L11.126 22.7191L11.1045 22.7038C11.0867 22.691 11.0619 22.6731 11.0306 22.6502C10.9681 22.6045 10.8795 22.5389 10.7686 22.4543C10.5469 22.2854 10.2352 22.0406 9.8635 21.7284C9.12221 21.1059 8.13073 20.2063 7.13473 19.0989C5.1959 16.9432 3 13.7362 3 10.1C3 5.093 7.01077 1 12 1C16.9892 1 21 5.093 21 10.1C21 13.7362 18.8041 16.9432 16.8653 19.0989C15.8693 20.2063 14.8778 21.1059 14.1365 21.7284C13.7647 22.0406 13.4531 22.2854 13.2314 22.4543C13.1205 22.5389 13.0319 22.6045 12.9694 22.6502C12.9381 22.6731 12.9133 22.691 12.8955 22.7038L12.874 22.7191L12.8672 22.7239L12.8632 22.7267L12 21.5ZM12 21.5C12 21.5 19.5 16.2222 19.5 10.1C19.5 5.90264 16.1421 2.5 12 2.5C7.85786 2.5 4.5 5.90264 4.5 10.1C4.5 16.2222 12 21.5 12 21.5Z"
                        fill={color}
                    />
                    <path
                        d="M12 21.5C11.1368 22.7267 11.1368 22.7267 11.1368 22.7267C11.6546 23.0911 12.3454 23.0911 12.8632 22.7267C12.8632 22.7267 12.8632 22.7267 12 21.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
